<template>
  <svg width="101" height="24" viewBox="0 0 101 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.9906 4.80005H15.588V16.984H17.9906V4.80005Z" fill="white" />
    <path d="M12.828 5.48182H10.4253V17.6655H12.828V5.48182Z" fill="white" />
    <path d="M7.66531 6.24296H5.26263V18.429H7.66531V6.24296Z" fill="white" />
    <path d="M2.50265 7.01255H0.0999756L0.0999847 19.2H2.50266L2.50265 7.01255Z" fill="white" />
    <path
      d="M81.4494 11.2915L77.5808 6.99022H75.3191V16.9492H77.6805V10.5952L81.2124 14.3597H81.6488L85.12 10.5952V16.9492H87.4814V6.99022H85.2198L81.4494 11.2915Z"
      fill="white"
    />
    <path
      d="M98.7313 6.99022L92.8785 13.4632V6.99022H90.5172V16.9492H92.6805L98.5333 10.4762V16.9492H100.895V6.99022H98.7313Z"
      fill="white"
    />
    <path
      d="M62.6002 10.6343C62.6002 12.22 63.4673 13.469 64.7983 13.9927L62.3025 16.9492H65.1928L67.4631 14.2596H69.9198V16.9492H72.2812V6.99022H66.2694C64.028 6.99022 62.6002 8.52359 62.6002 10.6343ZM69.9213 9.18366V12.1286H66.7073C65.635 12.1286 65.0598 11.5309 65.0598 10.6547C65.0598 9.77844 65.6552 9.18076 66.7073 9.18076L69.9213 9.18366Z"
      fill="white"
    />
    <path
      d="M51.6271 8.98201C51.4826 12.4071 50.76 14.6179 49.3452 14.6179H48.9912V17.0087L49.3684 17.029C52.2052 17.1871 53.7731 14.6977 54.0304 9.26055H57.7617V16.9492H60.1187V6.99022H51.7066L51.6271 8.98201Z"
      fill="white"
    />
    <path
      d="M42.7382 6.85107C39.5444 6.85107 37.2466 9.06192 37.2466 11.9691C37.2466 14.9764 39.7467 17.1089 42.7382 17.1089C45.8539 17.1089 48.2745 14.8574 48.2745 11.9691C48.2745 9.08078 45.8539 6.85107 42.7382 6.85107ZM42.7382 14.7182C40.9332 14.7182 39.7034 13.5431 39.7034 11.9691C39.7034 10.3559 40.9346 9.2128 42.7382 9.2128C44.5417 9.2128 45.8134 10.4082 45.8134 11.9691C45.8134 13.5301 44.5244 14.7182 42.7382 14.7182Z"
      fill="white"
    />
    <path
      d="M34.7423 7.009H26.4082L26.3287 9.0008C26.2102 11.8703 25.4616 14.599 24.0468 14.6382L23.3922 14.6585V19.2002L25.7737 19.1954V16.9506H34.0472V19.1954H36.449V14.6382H34.7423V7.009ZM32.3809 14.6382H27.3417C28.1943 13.3442 28.651 11.4713 28.7305 9.28078H32.3809V14.6382Z"
      fill="white"
    />
  </svg>
</template>
